export default __webpack_public_path__ + "static/media/6.dd241265.svg";